var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4602_1935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8182 32.8182C32.194 33.4881 31.4412 34.0253 30.6049 34.398C29.7685 34.7707 28.8657 34.971 27.9502 34.9872C27.0347 35.0033 26.1254 34.8349 25.2764 34.492C24.4274 34.1491 23.6562 33.6387 23.0087 32.9912C22.3613 32.3438 21.8509 31.5726 21.508 30.7236C21.1651 29.8746 20.9967 28.9653 21.0128 28.0498C21.029 27.1343 21.2293 26.2315 21.602 25.3951C21.9746 24.5587 22.5119 23.806 23.1818 23.1818M41.5 41.5C37.615 44.4614 32.8843 46.102 28 46.1818C12.0909 46.1818 3 28 3 28C5.82702 22.7316 9.74803 18.1286 14.5 14.5C25.0442 25.0441 30.9558 30.9558 41.5 41.5ZM23.2273 10.3636C24.7917 9.99744 26.3933 9.8144 28 9.81817C43.9091 9.81817 53 28 53 28C51.6204 30.5809 49.9751 33.0108 48.0909 35.25L23.2273 10.3636Z",
    stroke: "#00793A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3L53 53",
    stroke: "#00793A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4602_1935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.5455,
    height: 54.5455,
    fill: "white",
    transform: "translate(0.727295 0.727295)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/ClosedEye.e554af52.svg";
export { ForwardRef as ReactComponent };